import { Subject } from "rxjs";

export interface ProgramRunDialogRequest {
  /** what the dialog is titled: the job's name */
  title: string;
  /** the jobevent Run (or Resume) made: the dialog follows the checkpoint process its run belongs to */
  jobEventUid: string;
}

/** Emit a request to open the program run dialog, or undefined to close it. Kept out of the .tsx so
 *  the dialog module exports only components (a React Fast Refresh requirement). */
export const showProgramRunDialog = new Subject<ProgramRunDialogRequest | undefined>();

export function openProgramRunDialog(req: ProgramRunDialogRequest): void {
  showProgramRunDialog.next(req);
}
